import { RouterProvider } from 'react-router-dom';
import router from '@app/routes';
import { AuthProvider } from '@providers/AuthProvider/ui/AuthProvider.tsx';
import { AudioProvider } from '@providers/AudioProvider/AudioProvider';
import ThemeCustomization from '@app/themes';
import Locales from '@components/common/Locales.tsx';
import NavigationScroll from '@layout/NavigationScroll.tsx';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ErrorBoundary from '@components/ErrorBoundary/ui/ErrorBoundary.tsx';

/**
 * @description main App component. It wraps the entire application with the necessary providers.
 * and then renders the RouterProvider with the router configuration.
 *
 * The outermost ErrorBoundary catches any uncaught render-time error in the
 * entire tree. Without it, an exception thrown inside any provider or route
 * blanks the app to a white screen with no recovery path.
 */
function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AudioProvider>
          <ThemeCustomization>
            <Locales>
              <NavigationScroll>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <RouterProvider router={router} />
                </LocalizationProvider>
              </NavigationScroll>
            </Locales>
          </ThemeCustomization>
        </AudioProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
